import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { RegularNotificationMessage } from 'components/shared/forms/notificationMessage/regular';

type LeverageWarnings = {
  [key: string]: {
    text: string;
  };
};

export type MessageDataType = {
  leverageWarnings: LeverageWarnings;
};

interface IProps {
  message?: LeverageWarnings;
}

export const UserLeverageHint = memo((props: IProps): JSX.Element | null => {
  const { i18n } = useTranslation();
  const currentMessage = () => {
    if (!props.message) {
      return '';
    }

    return props.message[i18n.language]?.text || '';
  };

  return <RegularNotificationMessage message={currentMessage()} />;
});
